import { Component, Input, ElementRef, Renderer2, HostBinding } from '@angular/core';

@Component({
  selector: 'bp-breadcrumb-item',
  exportAs: 'bpBreadcrumbItem',
  template: `<ng-content></ng-content>`,
})
export class BpBreadcrumbItemComponent {
  @Input() @HostBinding('class.active') active: boolean;
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'breadcrumb-item');
  }
}
